import { render, staticRenderFns } from "./RecordingComments.vue?vue&type=template&id=2eb9a64c&"
import script from "./RecordingComments.vue?vue&type=script&lang=js&"
export * from "./RecordingComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports